module.exports = __webpack_public_path__ + "static/media/phonyphones-netlify-contacts.91094925.png";